"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLASS_UNSUPPORTED = exports.CLASS_UNSELECTABLE = exports.CLASS_SELECTABLE = exports.CLASS_HIDDEN = exports.CLASS_CONTROL = exports.CLASS_COLLAPSED = void 0;
exports.cssOpacity = cssOpacity;
exports.getFontParameters = void 0;

/**
 * @module ol/css
 */

/**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */

/**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */
var CLASS_HIDDEN = 'ol-hidden';
/**
 * The CSS class that we'll give the DOM elements to have them selectable.
 *
 * @const
 * @type {string}
 */

exports.CLASS_HIDDEN = CLASS_HIDDEN;
var CLASS_SELECTABLE = 'ol-selectable';
/**
 * The CSS class that we'll give the DOM elements to have them unselectable.
 *
 * @const
 * @type {string}
 */

exports.CLASS_SELECTABLE = CLASS_SELECTABLE;
var CLASS_UNSELECTABLE = 'ol-unselectable';
/**
 * The CSS class for unsupported feature.
 *
 * @const
 * @type {string}
 */

exports.CLASS_UNSELECTABLE = CLASS_UNSELECTABLE;
var CLASS_UNSUPPORTED = 'ol-unsupported';
/**
 * The CSS class for controls.
 *
 * @const
 * @type {string}
 */

exports.CLASS_UNSUPPORTED = CLASS_UNSUPPORTED;
var CLASS_CONTROL = 'ol-control';
/**
 * The CSS class that we'll give the DOM elements that are collapsed, i.e.
 * to those elements which usually can be expanded.
 *
 * @const
 * @type {string}
 */

exports.CLASS_CONTROL = CLASS_CONTROL;
var CLASS_COLLAPSED = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */

exports.CLASS_COLLAPSED = CLASS_COLLAPSED;
var fontRegEx = new RegExp(['^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)', '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)', '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)', '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?', '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))', '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))', '?\\s*([-,\\"\\\'\\sa-z]+?)\\s*$'].join(''), 'i');
var fontRegExMatchIndex = ['style', 'variant', 'weight', 'size', 'lineHeight', 'family'];
/**
 * Get the list of font families from a font spec.  Note that this doesn't work
 * for font families that have commas in them.
 * @param {string} fontSpec The CSS font property.
 * @return {FontParameters|null} The font parameters (or null if the input spec is invalid).
 */

var getFontParameters = function getFontParameters(fontSpec) {
  var match = fontSpec.match(fontRegEx);

  if (!match) {
    return null;
  }

  var style =
  /** @type {FontParameters} */
  {
    lineHeight: 'normal',
    size: '1.2em',
    style: 'normal',
    weight: 'normal',
    variant: 'normal'
  };

  for (var i = 0, ii = fontRegExMatchIndex.length; i < ii; ++i) {
    var value = match[i + 1];

    if (value !== undefined) {
      style[fontRegExMatchIndex[i]] = value;
    }
  }

  style.families = style.family.split(/,\s?/);
  return style;
};
/**
 * @param {number} opacity Opacity (0..1).
 * @return {string} CSS opacity.
 */


exports.getFontParameters = getFontParameters;

function cssOpacity(opacity) {
  return opacity === 1 ? '' : String(Math.round(opacity * 100) / 100);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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